export const actions = {
  ETIQUETAS_LOAD_REQUESTED: 'ETIQUETAS_LOAD_REQUESTED',
  ETIQUETAS_LOAD_SUCCEEDED: 'ETIQUETAS_LOAD_SUCCEEDED',
  ETIQUETAS_LOAD_FILED: 'ETIQUETAS_LOAD_FILED',

  ETIQUETAS_LOAD_ALL_REQUESTED: 'ETIQUETAS_LOAD_ALL_REQUESTED',
  ETIQUETAS_LOAD_ALL_SUCCEEDED: 'ETIQUETAS_LOAD_ALL_SUCCEEDED',
  ETIQUETAS_LOAD_ALL_FILED: 'ETIQUETAS_LOAD_ALL_FILED',

  ETIQUETA_BYID_LOAD_REQUESTED: 'ETIQUETA_BYID_LOAD_REQUESTED',
  ETIQUETA_BYID_LOAD_SUCCEEDED: 'ETIQUETA_BYID_LOAD_SUCCEEDED',
  ETIQUETA_BYID_LOAD_FILED: 'ETIQUETA_BYID_LOAD_FILED',

  ETIQUETA_UPDATE_REQUESTED: 'ETIQUETA_UPDATE_REQUESTED',
  ETIQUETA_UPDATE_SUCCEEDED: 'ETIQUETA_UPDATE_SUCCEEDED',
  ETIQUETA_UPDATE_FILED: 'ETIQUETA_UPDATE_FILED',

  ETIQUETA_INSERT_REQUESTED: 'ETIQUETA_INSERT_REQUESTED',
  ETIQUETA_INSERT_SUCCEEDED: 'ETIQUETA_INSERT_SUCCEEDED',
  ETIQUETA_INSERT_FILED: 'ETIQUETA_INSERT_FILED',

  ETIQUETA_BYID_LOAD_INSERT_REQUESTED: 'ETIQUETA_BYID_LOAD_INSERT_REQUESTED',

  ETIQUETA_DELETE_REQUESTED: 'ETIQUETA_DELETE_REQUESTED',
  ETIQUETA_DELETE_SUCCEEDED: 'ETIQUETA_DELETE_SUCCEEDED',
  ETIQUETA_DELETE_FILED: 'ETIQUETA_DELETE_FILED',

  ETIQUETA_SORT_ITEMS_UPDATE_REQUESTED: 'ETIQUETA_SORT_ITEMS_UPDATE_REQUESTED',
  ETIQUETA_SORT_ITEMS_UPDATE_SUCCEEDED: 'ETIQUETA_SORT_ITEMS_UPDATE_SUCCEEDED',
  ETIQUETA_SORT_ITEMS_UPDATE_FILED: 'ETIQUETA_SORT_ITEMS_UPDATE_FILED',
}

export const getEtiquetasByPadreIdAction = (dispatch, padreId) => {
  dispatch({
    type: actions.ETIQUETAS_LOAD_REQUESTED,
    payload: padreId,
  })
}

export const getEtiquetasAction = dispatch => {
  dispatch({
    type: actions.ETIQUETAS_LOAD_ALL_REQUESTED,
  })
}

export const deleteEtiquetaAction = (dispatch, id) => {
  dispatch({
    type: actions.ETIQUETA_DELETE_REQUESTED,
    payload: id,
  })
}

export const getEtiquetaCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.ETIQUETA_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.ETIQUETA_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertEtiquetaFormAction = (dispatch, formEtiqueta) => {
  dispatch({
    type: actions.ETIQUETA_INSERT_REQUESTED,
    payload: formEtiqueta,
  })
}

export const onSubmitUpdateEtiquetaFormAction = (dispatch, formEtiqueta) => {
  dispatch({
    type: actions.ETIQUETA_UPDATE_REQUESTED,
    payload: formEtiqueta,
  })
}

export const onSubmitEtiquetasSortItemsUpdateAction = (dispatch, formEtiqueta) => {
  dispatch({
    type: actions.ETIQUETA_SORT_ITEMS_UPDATE_REQUESTED,
    payload: formEtiqueta,
  })
}
